import { Box, Checkbox, FormControlLabel, Tooltip, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";

const CheckBox = ({
  label = "",
  checked,
  onChange = () => { },
  Icon = MdOutlineRadioButtonUnchecked,
  CheckIcon = IoMdCheckmarkCircle,
  readOnly = false,
  disabled = false,
  tooltip
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%" }}>
      <FormControlLabel
        label={
          <Tooltip title={t(tooltip || "")} arrow placement="right">
            <Typography sx={{
              fontFamily: "Poppins",
              fontSize: 13,
              fontWeight: 500,
              color: theme.palette.text.subtitle,
              ml: 1,
              display: 'inline-block',
              verticalAlign: 'middle',
              pt: '1px'
            }}>
              {t(label)}
            </Typography>
          </Tooltip>
        }
        control={
          <Checkbox
            disableRipple
            checked={checked}
            onChange={onChange}
            icon={<Icon size={20} />}
            checkedIcon={<CheckIcon size={20} />}
            readOnly={readOnly}
            disabled={disabled}
            sx={{
              p: 0,
              color: theme.palette.text.subtitle,
              "&.Mui-checked": { color: theme.palette.mode === "dark" ? "#4ade80" : "#659d33" }
            }}
          />
        }
        sx={{
          m: 0,
          display: 'flex',
          alignItems: 'center'
        }}
      />
    </Box>
  );
};

export default CheckBox;
